import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

// Modules
import user from './user'
import bugReport from './bugReport'
import systemSetup from './systemSetup'
import customers from './customers'
import tasks from './tasks'
import uploader from './uploader'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    bugReport,
    systemSetup,
    customers,
    tasks,
    uploader
  },
  state: {
    // DB
    entities: {
      users: {},
      usersList: [],
      firebaseUsers: {},
      firebaseUsersList: [],
      invoices: {},
      invoicesList: [],
      notes: {},
      notesList: [],
      tasks: {},
      tasksList: [],
      taskTypes: {},
      taskTypesList: [],
      stores: {},
      storesList: [],
      storeTypes: {},
      storeTypesList: [],
      storeTransfers: {},
      storeTransfersList: [],
      customers: {},
      customersList: [],
      orders: {},
      ordersList: [],
      agentTypes: {},
      agentTypesList: [],
      coupons: {},
      couponsList: [],
      returnTypes: {},
      returnTypesList: [],
      receiveTypes: {},
      receiveTypesList: [],
      orderStatuses: {},
      orderStatusesList: [],
      orderItems: {},
      orderItemsList: [],
      orderItemTypes: {},
      orderItemTypesList: [],
      devices: {},
      devicesList: [],
      deviceTypes: {},
      deviceTypesList: [],
      networkStatusTypes: {},
      networkStatusTypesList: [],
      emailTypes: {},
      emailTypesList: [],
      addons: {},
      addonsList: [],
      overragePrices: {},
      overragePricesList: [],
      smsTypes: {},
      smsTypesList: [],
      boxTypes: {},
      boxTypesList: [],
      payments: {},
      paymentsList: [],
      deliveries: {},
      deliveriesList: [],
      deliveryItems: {},
      deliveryItemssList: [],
      roles: {},
      rolesList: [],
    },
    editableEntities: {
      users: {},
      invoices: {},
      notes: {},
      tasks: {},
      taskTypes: {},
      stores: {},
      storeTypes: {},
      storeTransfers: {},
      customers: {},
      orders: {},
      agentTypes: {},
      coupons: {},
      returnTypes: {},
      receiveTypes: {},
      orderStatuses: {},
      orderItems: {},
      orderItemTypes: {},
      devices: {},
      deviceTypes: {},
      networkStatusTypes: {},
      emailTypes: {},
      addons: {},
      overragePrices: {},
      smsTypes: {},
      boxTypes: {},
      payments: {},
      deliveries: {},
      deliveryItems: {},
      roles: {},
    },

    storeTransferDialog: false,
    bulkDevicesDialog: false,
    deliveryHasArrivedDialog: false,
    bookOutDialog: false,
    checkInDialog: false,
    cancelOrderDialog: false,
    finalizeDialog: false,
    sendEmailDialog: false,
    sendSmsDialog: false,
    paymentDialog: false,

    entityEditDialog: false,
    entityEditData: {
      id: null,
      fields: null,
      resource: null,
      mainId: null,
      mainResource: null,
    },

    resources: {
      note: {
        model: {
          text: {
            type: 'TEXTAREA',
            name: 'הערה',
            validationRules: [v => !!v || 'חובה לכתוב הערה'],
            required: true
          },
          task: {
            type: 'HIDDEN'
          },
          device: {
            type: 'HIDDEN'
          },
          customer: {
            type: 'HIDDEN'
          },
          order: {
            type: 'HIDDEN'
          },
          delivery: {
            type: 'HIDDEN'
          },
          user: {
            type: 'HIDDEN'
          }
        },
        endpoint: '/notes',
        entityType: 'notes',
        schema: 'noteSchema',
        listSchema: 'noteListSchema',
        name: 'הערה',
        namePlural: 'הערות'
      },
      invoice: {
        model: {
          sentByEmail: {
            type: 'BOOLEAN',
            name: 'האם חשבונית נשלחה במייל',
            validationRules: [],
            required: true,
          }
        },
        endpoint: '/invoices',
        entityType: 'invoices',
        schema: 'invoiceSchema',
        listSchema: 'invoiceListSchema',
        name: 'חשבונית',
        namePlural: 'חשבוניות'
      },
      coupon: {
        systemSetup: true,
        model: {
          _id: {
            type: 'TEXT',
            name: 'מזהה',
            validationRules: [v => !!v || 'חובה להזין מזהה'],
            required: true
          },
          name: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          description: {
            type: 'TEXT',
            name: 'תיאור',
            validationRules: [],
            required: false
          },
          terms: {
            type: 'TEXT',
            name: 'תנאים',
            validationRules: [],
            required: false
          },
          code: {
            type: 'TEXT',
            name: 'קוד',
            validationRules: [],
            required: false
          },
          image: {
            type: 'TEXT',
            name: 'כתובת תמונה',
            validationRules: [],
            required: false,
            ltr: true
          },
          forceInvalid: {
            type: 'BOOLEAN',
            name: 'כבוי באופן יזום',
            validationRules: [],
            required: false,
          },
          startDate: {
            type: 'DATE',
            name: 'תאריך התחלה',
            validationRules: [v => !!v || 'חובה לבחור תאריך התחלה'],
            required: true
          },
          endDate: {
            type: 'DATE',
            name: 'תאריך סיום',
            validationRules: [v => !!v || 'חובה לבחור תאריך סיום'],
            required: true
          },
          usageLimit: {
            type: 'NUMBER',
            name: 'מגבלת שימוש',
            validationRules: [],
            required: false,
            hint: 'אפשר להשאיר ריק כדי לא להגדיר מגבלה'
          },
          discountOnMinimumOrder: {
            type: 'BOOLEAN',
            name: 'הנחה על מחיר מינימלי',
            validationRules: [],
            required: false,
          },
          minimumOrderDisabled: {
            type: 'BOOLEAN',
            name: 'ביטול מחיר מינימלי',
            validationRules: [],
            required: false,
          },
          precentage: {
            type: 'NUMBER',
            name: 'אחוזי הנחה',
            validationRules: [],
            required: false,
            hint: 'למשל: 50'
          },
          lametayelPart: {
            type: 'NUMBER',
            name: 'השתתפות למטייל בהנחה',
            validationRules: [],
            required: false,
            hint: 'למשל: 50'
          },
          fixDiscount: {
            type: 'NUMBER',
            name: 'הנחה קבועה',
            validationRules: [],
            required: false,
            hint: 'למשל: 200'
          },
          numberOfDaysWithFreeAddons: {
            type: 'NUMBER',
            name: 'מספר ימים של תוספות חינם',
            validationRules: [],
            required: false,
            hint: 'למשל: 30'
          },
        },
        modelName: 'Coupon',
        endpoint: '/coupons',
        entityType: 'coupons',
        schema: 'couponSchema',
        listSchema: 'couponListSchema',
        name: 'קופון',
        namePlural: 'קופונים'
      },
      orderStatus: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          }
        },
        modelName: 'OrderStatus',
        endpoint: '/order-statuses',
        entityType: 'orderStatuses',
        schema: 'orderStatusSchema',
        listSchema: 'orderStatusListSchema',
        name: 'סטטוס הזמנה',
        namePlural: 'סטטוסי הזמנה'
      },
      orderItem: {
        model: {
          order: {
            type: 'HIDDEN'
          },
          type: {
            type: 'SELECT',
            items: 'orderItemTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג פריט',
            validationRules: [v => !!v || 'חובה לבחור סוג פריט'],
            required: true
          },
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true,
            viewIf: (item, store) => {
              let orderItemType = store.state.entities.orderItemTypes[item.type];
              return orderItemType && orderItemType.key === 'OTHER';
            }
          },
          price: {
            type: 'NUMBER',
            name: 'מחיר',
            validationRules: [v => !!v || 'חובה להזין מחיר'],
            required: true,
            viewIf: (item, store) => {
              let orderItemType = store.state.entities.orderItemTypes[item.type];
              return orderItemType && orderItemType.key === 'OTHER';
            }
          },
          deviceType: {
            type: 'SELECT',
            items: 'deviceTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג מכשיר',
            validationRules: [v => !!v || 'חובה לבחור סוג מכשיר'],
            required: true,
            viewIf: (item, store) => {
              let orderItemType = store.state.entities.orderItemTypes[item.type];
              return orderItemType && orderItemType.key === 'DEVICE';
            },
          },
          returnType: {
            type: 'SELECT',
            items: 'returnTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג החזרה',
            validationRules: [v => !!v || 'חובה לבחור סוג החזרה'],
            required: true,
            viewIf: (item, store) => {
              let orderItemType = store.state.entities.orderItemTypes[item.type];
              return orderItemType && orderItemType.key === 'RETURN';
            },
          },
          receiveType: {
            type: 'SELECT',
            items: 'receiveTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג מסירה',
            validationRules: [v => !!v || 'חובה לבחור סוג מסירה'],
            required: true,
            viewIf: (item, store) => {
              let orderItemType = store.state.entities.orderItemTypes[item.type];
              return orderItemType && orderItemType.key === 'RECEIVE';
            }
          },
          addon: {
            type: 'SELECT',
            items: 'addons',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג תוספת',
            validationRules: [v => !!v || 'חובה לבחור סוג תוספת'],
            required: true,
            viewIf: (item, store) => {
              let orderItemType = store.state.entities.orderItemTypes[item.type];
              return orderItemType && orderItemType.key === 'ADDON';
            }
          },
          vat: {
            type: 'BOOLEAN',
            name: 'מע״מ',
            validationRules: [],
            required: true,
          }
        },
        modelName: 'OrderItem',
        endpoint: '/order-items',
        entityType: 'orderItems',
        schema: 'orderItemSchema',
        listSchema: 'orderItemListSchema',
        name: 'פריט',
        namePlural: 'פריטים'
      },
      orderItemType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        modelName: 'OrderItemType',
        endpoint: '/order-item-types',
        entityType: 'orderItemTypes',
        schema: 'orderItemTypeSchema',
        listSchema: 'orderItemTypeListSchema',
        name: 'סוג פריט',
        namePlural: 'סוגי פריטים'
      },
      returnType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          price: {
            type: 'NUMBER',
            name: 'מחיר',
            validationRules: [v => !!v || 'חובה להזין מחיר'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        modelName: 'ReturnType',
        endpoint: '/return-types',
        entityType: 'returnTypes',
        schema: 'returnTypeSchema',
        listSchema: 'returnTypeListSchema',
        name: 'סוג החזרה',
        namePlural: 'סוגי החזרה'
      },
      receiveType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          price: {
            type: 'NUMBER',
            name: 'מחיר',
            validationRules: [v => !!v || 'חובה להזין מחיר'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        modelName: 'ReceiveType',
        endpoint: '/receive-types',
        entityType: 'receiveTypes',
        schema: 'receiveTypeSchema',
        listSchema: 'receiveTypeListSchema',
        name: 'סוג מסירה',
        namePlural: 'סוגי מסירה'
      },
      payment: {
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          totalWithVat: {
            type: 'NUMBER',
            name: 'סה״כ באגורות פריטים ללא מע״מ',
            ltr: true
          },
          totalWithoutVat: {
            type: 'NUMBER',
            name: 'סה״כ באגורות פריטים עם מע״מ',
            ltr: true
          },
          order: {
            type: 'HIDDEN'
          }
        },
        modelName: 'Payment',
        endpoint: '/payments',
        entityType: 'payments',
        schema: 'paymentSchema',
        listSchema: 'paymentListSchema',
        name: 'חיוב / זיכוי',
        namePlural: 'חיובים וזיכויים'
      },
      agentType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          }
        },
        modelName: 'AgentType',
        endpoint: '/agent-types',
        entityType: 'agentTypes',
        schema: 'agentTypeSchema',
        listSchema: 'agentTypeListSchema',
        name: 'סוג סוכן',
        namePlural: 'סוגי סוכנים'
      },
      delivery: {
        model: {
          date: {
            type: 'DATE',
            name: 'תאריך שילוח',
            validationRules: [v => !!v || 'חובה לבחור תאריך שילוח'],
            required: true
          },
          tempStore: {
            type: 'SELECT',
            items: 'stores',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'חנות ביניים',
            validationRules: [v => !!v || 'חובה לבחור חנות ביניים'],
            required: true
          },
          // tempBoxType: {
          //   type: 'SELECT',
          //   items: 'boxTypes',
          //   itemText: 'title',
          //   itemValue: '_id',
          //   isMultiple: false,
          //   name: 'מגירת ביניים',
          //   validationRules: [v => !!v || 'חובה לבחור מגירת ביניים'],
          //   required: true
          // },
          isReady: {
            type: 'BOOLEAN',
            name: 'מוכן',
            validationRules: [],
            required: false
          },
          isDeliveredToTempStore: {
            type: 'BOOLEAN',
            name: 'הועבר לשליח',
            validationRules: [],
            required: false
          },
          isDeliveredToFinalStore: {
            type: 'BOOLEAN',
            name: 'הגיע במלואו אל היעד',
            validationRules: [],
            required: false
          },
        },
        modelName: 'Delivery',
        endpoint: '/deliveries',
        entityType: 'deliveries',
        schema: 'deliverySchema',
        listSchema: 'deliveryListSchema',
        name: 'משלוח',
        namePlural: 'משלוחים'
      },
      deliveryItem: {
        model: {
          store: {
            type: 'SELECT',
            items: 'stores',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'חנות',
            validationRules: [v => !!v || 'חובה לבחור חנות'],
            required: true
          },
          boxType: {
            type: 'SELECT',
            items: 'boxTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'מגירה',
            validationRules: [],
            required: false
          },
          device: {
            type: 'SELECT',
            items: 'devices',
            itemText: 'imei',
            itemValue: '_id',
            isMultiple: false,
            name: 'מכשיר',
            validationRules: [],
            required: false
          },
          order: {
            type: 'SELECT',
            items: 'orders',
            itemText: '_id',
            itemValue: '_id',
            isMultiple: false,
            name: 'הזמנה',
            validationRules: [],
            required: false
          },
          isDelivered: {
            type: 'BOOLEAN',
            name: 'האם הגיע?',
            validationRules: [],
            required: false
          },
          delivery: {
            type: 'HIDDEN'
          },
          text: {
            type: 'TEXT',
            name: 'הערות',
            validationRules: [],
            required: false
          },
        },
        modelName: 'DeliveryItem',
        endpoint: '/delivery-items',
        entityType: 'deliveryItems',
        schema: 'deliveryItemSchema',
        listSchema: 'deliveryItemListSchema',
        name: 'פריט במשלוח',
        namePlural: 'פריטי משלוח'
      },
      task: {
        model: {
          dueDate: {
            type: 'DATE',
            name: 'תאריך לביצוע',
            validationRules: [v => !!v || 'חובה לבחור תאריך לביצוע'],
            required: true
          },
          type: {
            type: 'SELECT',
            items: 'taskTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג',
            validationRules: [v => !!v || 'חובה לבחור סוג'],
            required: true
          },
          order: {
            type: 'SELECT',
            items: 'orders',
            itemText: '_id',
            itemValue: '_id',
            isMultiple: false,
            name: 'הזמנה',
            validationRules: [],
            required: false
          },

        },
        modelName: 'Task',
        endpoint: '/tasks',
        entityType: 'tasks',
        schema: 'taskSchema',
        listSchema: 'taskListSchema',
        name: 'משימה',
        namePlural: 'משימות',
        redirectTo: '/tasks', 
        redirectOnlyFrom: ['Tasks']
      },
      taskType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/task-types',
        entityType: 'taskTypes',
        schema: 'taskTypeSchema',
        listSchema: 'taskTypeListSchema',
        name: 'סוג משימה',
        namePlural: 'סוגי משימות'
      },
      addon: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          pricePerDay: {
            type: 'NUMBER',
            name: 'מחיר ליום',
            validationRules: [v => !!v || 'חובה להזין מחיר'],
            required: true
          },
          forceVat: {
            type: 'BOOLEAN',
            name: 'תמיד חייב מע״מ',
            ltr: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/addons',
        entityType: 'addons',
        schema: 'addonSchema',
        listSchema: 'addonListSchema',
        name: 'תוספת',
        namePlural: 'תוספות'
      },
      overragePrice: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          price: {
            type: 'NUMBER',
            name: 'מחיר',
            validationRules: [v => !!v || 'חובה להזין מחיר'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          }
        },
        endpoint: '/overrage-prices',
        entityType: 'overragePrices',
        schema: 'overragePriceSchema',
        listSchema: 'overragePriceListSchema',
        name: 'מחיר חריגה',
        namePlural: 'מחירי חריגות'
      },
      storeType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          returnType: {
            type: 'SELECT',
            items: 'returnTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג החזרה',
            validationRules: [],
            required: false
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/store-types',
        entityType: 'storeTypes',
        schema: 'storeTypeSchema',
        listSchema: 'storeTypeListSchema',
        name: 'סוג חנות',
        namePlural: 'סוגי חנויות'
      },
      boxType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          readyForBookOut: {
            type: 'BOOLEAN',
            name: 'מוכן למסירה'
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/box-types',
        entityType: 'boxTypes',
        schema: 'boxTypeSchema',
        listSchema: 'boxTypeListSchema',
        name: 'סוג מגירה',
        namePlural: 'סוגי מגירות'
      },
      store: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            validationRules: [],
            required: false,
            ltr: true
          },
          type: {
            type: 'SELECT',
            items: 'storeTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג חנות',
            validationRules: [],
            required: false
          },
          boxTypes: {
            type: 'SELECT',
            items: 'boxTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: true,
            name: 'מגירות',
            validationRules: [],
            required: false
          },
          stockMinimum: {
            type: 'NUMBER',
            name: 'תקן למכשירים במלאי',
            validationRules: [],
            required: false,
            ltr: true
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/stores',
        entityType: 'stores',
        schema: 'storeSchema',
        listSchema: 'storeListSchema',
        name: 'חנות',
        namePlural: 'חנויות'
      },
      customer: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [],
            required: false
          },
          id: {
            type: 'TEXT',
            name: 'תעודת זהות',
            validationRules: [],
            required: false
          },
          phone: {
            type: 'TEXT',
            name: 'מספר טלפון',
            validationRules: [],
            required: false,
            ltr: true
          },
          email: {
            type: 'TEXT',
            name: 'כתובת אי-מייל',
            validationRules: [],
            required: false,
            ltr: true
          }
        },
        modelName: 'Customer',
        endpoint: '/customers',
        entityType: 'customers',
        schema: 'customerSchema',
        listSchema: 'customerListSchema',
        name: 'לקוח',
        namePlural: 'לקוחות'
      },
      device: {
        systemSetup: true,
        model: {
          type: {
            type: 'SELECT',
            items: 'deviceTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג מכשיר',
            validationRules: [],
            required: false
          },
          imei: {
            type: 'TEXT',
            name: 'IMEI',
            validationRules: [],
            required: false
          },
          serialNumber: {
            type: 'TEXT',
            name: 'מספר סידורי',
            validationRules: [],
            required: false
          },
          purchaseDate: {
            type: 'DATE',
            name: 'תאריך רכישה',
            validationRules: [],
            required: false
          },
          invoiceId: {
            type: 'TEXT',
            name: 'מספר חשבונית רכישה',
            validationRules: [],
            required: false
          },
          nowforce: {
            type: 'BOOLEAN',
            name: 'משויך למוקד טבע',
            validationRules: [],
            required: false
          }
        },
        modelName: 'Product',
        endpoint: '/devices',
        entityType: 'devices',
        schema: 'deviceSchema',
        listSchema: 'deviceListSchema',
        name: 'מכשיר',
        namePlural: 'מכשירים'
      },
      deviceType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          longRental: {
            type: 'NUMBER',
            name: 'ימים לפני הפחתת מחיר',
            validationRules: [v => !!v || 'חובה להזין ימים'],
            required: true
          },
          pricePerDay: {
            type: 'NUMBER',
            name: 'מחיר ליום',
            validationRules: [v => !!v || 'חובה להזין מחיר'],
            required: true
          },
          pricePerDayLongRental: {
            type: 'NUMBER',
            name: 'מחיר ליום תעריף מופחת',
            validationRules: [v => !!v || 'חובה להזין מחיר'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/device-types',
        entityType: 'deviceTypes',
        schema: 'deviceTypeSchema',
        listSchema: 'deviceTypeListSchema',
        name: 'סוג מכשיר',
        namePlural: 'סוגי מכשירים'
      },
      networkStatusType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },

          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/network-status-types',
        entityType: 'networkStatusTypes',
        schema: 'networkStatusTypeSchema',
        listSchema: 'networkStatusTypeListSchema',
        name: 'סטאטוס תקשורת',
        namePlural: 'סטאטוסי תקשורת'
      },
      emailType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          templateId: {
            type: 'TEXT',
            name: 'מזהה sendgrid',
            ltr: true,
            validationRules: [v => !!v || 'חובה להזין מזהה'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/email-types',
        entityType: 'emailTypes',
        schema: 'emailTypeSchema',
        listSchema: 'emailTypeListSchema',
        name: 'סוג אימייל',
        namePlural: 'סוגי אי-מיילים'
      },
      smsType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          message: {
            type: 'TEXTAREA',
            name: 'הודעה',
            validationRules: [v => !!v || 'חובה להזין הודעה'],
            hint: 'משתנים יש לעטוף ב- {{}}',
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'מזהה',
            ltr: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/sms-types',
        entityType: 'smsTypes',
        schema: 'smsTypeSchema',
        listSchema: 'smsTypeListSchema',
        name: 'הודעת sms',
        namePlural: 'הודעות sms'
      },
      order: {
        model: {
          startDate: {
            type: 'DATE',
            name: 'תאריך התחלה',
            validationRules: [v => !!v || 'חובה לבחור תאריך התחלה'],
            required: true
          },
          endDate: {
            type: 'DATE',
            name: 'תאריך סיום',
            validationRules: [v => !!v || 'חובה לבחור תאריך סיום'],
            required: true
          },
          mapSharePassword: {
            type: 'TEXT',
            name: 'סיסמת מפה',
            ltr: true
          },
          token: {
            type: 'TEXT',
            name: 'טוקן אשראי',
            ltr: true
          },
          shipmentStore: {
            type: 'SELECT',
            items: 'stores',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'חנות מסירה',
            validationRules: [],
            required: false
          },
          device: {
            type: 'SELECT',
            items: 'devices',
            itemText: 'imei',
            itemValue: '_id',
            isMultiple: false,
            name: 'מכשיר',
            validationRules: [],
            required: true
          },
          coupon: {
            type: 'SELECT',
            items: 'coupons',
            itemText: 'name',
            itemValue: '_id',
            isMultiple: false,
            name: 'קופון',
            validationRules: [],
            required: true
          },
          status: {
            type: 'SELECT',
            items: 'orderStatuses',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סטטוס',
            validationRules: [],
            required: true
          },
        },
        endpoint: '/orders',
        entityType: 'orders',
        schema: 'orderSchema',
        listSchema: 'orderListSchema',
        name: 'הזמנה',
        namePlural: 'הזמנות'
      },
      orderAgent: {
        model: {
          agentId: {
            type: 'TEXT',
            name: 'מזהה מוכר',
            ltr: true
          },
          agentStore: {
            type: 'TEXT',
            name: 'מזהה חנות',
            ltr: true
          },
          agentType: {
            type: 'SELECT',
            items: 'agentTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג מוכר',
            validationRules: [],
            required: false
          },
        },
        endpoint: '/orders',
        entityType: 'orders',
        schema: 'orderSchema',
        listSchema: 'orderListSchema',
        name: 'הזמנה',
        namePlural: 'הזמנות'
      },
      orderBookOut: {
        model: {
          bookOutAgentId: {
            type: 'TEXT',
            name: 'מזהה סוכן',
            ltr: true
          },
          bookOutAgentStore: {
            type: 'TEXT',
            name: 'חנות סוכן',
            ltr: true
          },
          bookOutAgentType: {
            type: 'SELECT',
            items: 'agentTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג סוכן',
            validationRules: [],
            required: false
          },
        },
        endpoint: '/orders',
        entityType: 'orders',
        schema: 'orderSchema',
        listSchema: 'orderListSchema',
        name: 'הזמנה',
        namePlural: 'הזמנות'
      },
      orderCheckIn: {
        model: {
          checkInAgentId: {
            type: 'TEXT',
            name: 'מזהה סוכן',
            ltr: true
          },
          checkInAgentStore: {
            type: 'TEXT',
            name: 'חנות סוכן',
            ltr: true
          },
          checkInAgentType: {
            type: 'SELECT',
            items: 'agentTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג סוכן',
            validationRules: [],
            required: false
          },
        },
        endpoint: '/orders',
        entityType: 'orders',
        schema: 'orderSchema',
        listSchema: 'orderListSchema',
        name: 'הזמנה',
        namePlural: 'הזמנות'
      },
      storeTransfer: {
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          }
        },
        endpoint: '/store-transfers',
        entityType: 'storeTransfers',
        schema: 'storeTransferSchema',
        listSchema: 'storeTransferListSchema',
        name: 'העברת חנות',
        namePlural: 'העברות חנות'
      },
      user: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם מלא',
            validationRules: [v => !!v || 'חובה להזין שם מלא'],
            required: true
          },
          roles: {
            type: 'SELECT',
            items: 'roles',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: true,
            name: 'הרשאות',
            validationRules: [],
            required: false
          },
          agentType: {
            type: 'SELECT',
            items: 'agentTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'שיוך',
            validationRules: [],
            required: false
          },
          firebaseId: {
            type: 'SELECT',
            items: 'firebaseUsers',
            itemText: 'data',
            itemValue: '_id',
            isMultiple: true,
            name: 'חשבונות',
            validationRules: [],
            required: false
          },
          image: {
            type: 'IMAGE',
            name: 'תמונה',
            validationRules: [],
            required: false,
          },
          color: {
            type: 'COLOR',
            name: 'צבע',
            validationRules: [],
            required: false,
          },
          isActive: {
            type: 'BOOLEAN',
            name: 'משתמש פעיל',
            validationRules: [],
            required: false,
          }
        },
        endpoint: '/users',
        entityType: 'users',
        schema: 'userSchema',
        listSchema: 'userListSchema',
        name: 'משתמש',
        namePlural: 'משתמשים'
      },
      role: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'קוד',
            validationRules: [
              v => !!v || 'חובה להזין קוד',
              v => {
                if (['ADMIN', 'LAMETAYEL_MANAGER', 'LAMETAYEL_USER', 'OFFICE_USER', 'AIRPORT_USER'].indexOf(v) === -1) return 'קוד לא תקין';
                return true;
              }
            ],
            required: true
          }
        },
        endpoint: '/roles',
        entityType: 'roles',
        schema: 'roleSchema',
        listSchema: 'roleListSchema',
        name: 'סוג הרשאה',
        namePlural: 'סוגי הרשאות'
      },
      activityLog: {
        endpoint: 'activity-logs',
        entityType: 'activityLogs',
        schema: 'activityLogSchema',
        listSchema: 'activityLogListSchema',
        name: 'לוג פעולות'
      },

    },

    // UI
    fetching: false,
    nightMode: false,
    isMainMenuActive: null,
    shouldShowMainMenuAutomatically: true,
    mainMenuMiniVariant: false,
    snackbar: false,
    snackbarData: {
      text: '',
      color: ''
    },

    // System data
    contactDetailTypes: null,

  },
  actions,
  mutations,
  getters
})